import { render } from "./ProfileSortModels.vue?vue&type=template&id=7ebe1e46"
import script from "./ProfileSortModels.vue?vue&type=script&lang=js"
export * from "./ProfileSortModels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__